import { render, staticRenderFns } from "./AdminSubjectsStudentAssignment.vue?vue&type=template&id=0f296310"
import script from "./AdminSubjectsStudentAssignment.vue?vue&type=script&lang=js"
export * from "./AdminSubjectsStudentAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports